<template>
  <div class="progress-steps">
    <template v-if="steps.length">
      <div
        v-for="(step, index) in steps"
        :key="step.id"
        class="progress-step-extended"
        :class="{
          'progress-step-extended_current': isCurrentStep(step.id),
          'progress-step-extended_link': current > step.id,
          'progress-step-extended_next': current < step.id,
        }"
        @click="goToStepHandler(step.id)"
      >
        <Badge rounded :color="badgeColor(step.id)">
          <div v-if="current > step.id" class="progress-step-extended__icon">
            <Icon type="check" size="16" color="oncolor" />
          </div>
          <div v-else>
            {{ index + 1 }}
          </div>
        </Badge>
        <div class="progress-step-extended__text">{{ step.label }}</div>
      </div>
    </template>
    <template v-else-if="count">
      <div
        v-for="i in count"
        :key="i"
        class="progress-step"
        :class="{ 'progress-step_current': isCurrentStep(i) }"
      />
    </template>
  </div>
</template>

<script>
  import Badge from '@/components/ui/Badge';
  import Icon from '@/components/ui/Icon';
  export default {
    name: 'ProgressSteps',
    components: { Icon, Badge },
    props: {
      count: {
        type: Number,
        default: 1,
      },
      steps: {
        type: Array,
        default: () => [],
      },
      current: {
        type: Number,
        default: 1,
      },
    },
    methods: {
      isCurrentStep(step) {
        return Math.floor(this.current) === step;
      },
      badgeColor(stepId) {
        if (stepId < this.current) {
          return 'dark-green';
        }
        if (stepId > this.current) {
          return 'grey';
        }
        return 'blue';
      },
      goToStepHandler(stepId) {
        if (stepId < this.current) {
          this.$emit('go-to-step', stepId);
        }
      },
    },
  };
</script>
<style lang="scss">
  @import 'src/styles/components/progress-steps';
</style>
